import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import CandidateReportSummary from 'components/reports/candidate/candidate-report-summary';
import CandidateProfileAssessments from 'components/reports/candidate-profile/candidate-profile-assessments';
import { useAuth } from '../../providers/auth-provider';
import ReportsMenu from '../reports/shared/reports-menu';
import { Container } from 'react-bootstrap';
import { REPORT_TYPE } from '../../utils/constants';
import { isSelectStaffing } from '../../api/dashboards-api';

function ParticipantDetail({ show, onHide, candidate }) {
  const auth = useAuth();
  let reportType = REPORT_TYPE.coaching;
  if (auth.isDevelop() || isSelectStaffing()) {
    reportType = REPORT_TYPE.development;
  }

  return (
    <Modal size="xl" show={show} onHide={onHide} centered>
      <Modal.Header>
        <Modal.Title>{candidate?.name}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="candidates-modal-body">
        {auth.isSelect() && (
          <>
            <h6>Position: {candidate?.position}</h6>
            <h6>Hiring Manager: {candidate?.hiringManager}</h6>
          </>
        )}
        {candidate && (
          <div className="candidates-modal-content">
            <CandidateReportSummary candidate={candidate} displayPercentile={false} reportType={reportType} />
            <CandidateProfileAssessments candidate={candidate} displayPercentile={false} reportType={reportType} />
            <Container className="w-75">
              <ReportsMenu reference={candidate.reference} />
            </Container>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onHide} variant="primary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ParticipantDetail;
